import { render } from "./FriendListView.vue?vue&type=template&id=2f1035e4"
import script from "./FriendListView.vue?vue&type=script&lang=js"
export * from "./FriendListView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__